import { SELECIONAR_EMISSAO_CTE_OS  } from '../types'

export default function selecionarEmissaoCteOs (emissaoCteOs) {
  return {
    type: SELECIONAR_EMISSAO_CTE_OS,
    payload: emissaoCteOs
  }
}
